/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Integrations_Web_NoteInputs */

const tr_landing_integrations_web_note = /** @type {(inputs: Landing_Integrations_Web_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mağazanızı emonse EDITOR ile kendiniz tasarlarsınız: bölümleri sürükleyip bırakın, kod yazmayın. Kendi alan adınızda ya da adiniz.emonseweb.com adresinde yayına girer.`)
};

const en_landing_integrations_web_note = /** @type {(inputs: Landing_Integrations_Web_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You design the store yourself with emonse EDITOR: drag and drop the sections, no code. It goes live on your own domain, or as name.emonseweb.com.`)
};

const de_landing_integrations_web_note = /** @type {(inputs: Landing_Integrations_Web_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Den Shop gestalten Sie selbst mit emonse EDITOR: Bereiche ziehen und ablegen, ohne eine Zeile Code. Er geht unter Ihrer eigenen Domain live oder als name.emonseweb.com.`)
};

const ru_landing_integrations_web_note = /** @type {(inputs: Landing_Integrations_Web_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Магазин вы собираете сами в emonse EDITOR: перетаскивайте блоки, без кода. Он работает на вашем домене или по адресу name.emonseweb.com.`)
};

/**
* | output |
* | --- |
* | "You design the store yourself with emonse EDITOR: drag and drop the sections, no code. It goes live on your own domain, or as name.emonseweb.com." |
*
* @param {Landing_Integrations_Web_NoteInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_integrations_web_note = /** @type {((inputs?: Landing_Integrations_Web_NoteInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Integrations_Web_NoteInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_integrations_web_note(inputs)
	if (locale === "de") return de_landing_integrations_web_note(inputs)
	if (locale === "ru") return ru_landing_integrations_web_note(inputs)
	return tr_landing_integrations_web_note(inputs)
});